import { createSelector } from 'reselect';
export const getState = (state) => state.aviaOrder;
export const getAviaOrderExareInfo = createSelector(getState, aviaOrder => aviaOrder.exareInfo);
export const getIsAutoModeAllowed = createSelector(getAviaOrderExareInfo, exareInfo => exareInfo.refundAutoMode);
export const getAviaOrderTravellers = createSelector(getState, aviaOrder => aviaOrder.travellers);
export const getCustomer = createSelector(getState, aviaOrder => aviaOrder.customer);
export const hasNasServices = createSelector(getState, aviaOrder => !!aviaOrder.price.nas);
export const getAviaOrderStateHash = createSelector(getState, aviaOrder => aviaOrder.stateHash);
